import { getResourceCode } from '../';
import { $definitions, CONDITION_CLINICAL_STATUS_SELECT_ID, CONDITION_ONSET_SELECT_ID, CONDITION_SEVERITY_SELECT_ID, CONDITION_VERIFICATION_STATUS_SELECT_ID, } from '../../definitions';
export class ConditionExtractor {
    constructor(resource, additional = {}) {
        this._data = resource;
        this.additional = additional;
    }
    get data() {
        return this._data;
    }
    get code() {
        return getResourceCode(this.data.code);
    }
    get status() {
        return $definitions.selects.getValue(CONDITION_CLINICAL_STATUS_SELECT_ID, this.data.clinicalStatus || this.additional.status);
    }
    get verificationStatus() {
        return $definitions.selects.getValue(CONDITION_VERIFICATION_STATUS_SELECT_ID, this.data.verificationStatus || this.additional.verificationStatus);
    }
    get severity() {
        return $definitions.selects.getValue(CONDITION_SEVERITY_SELECT_ID, this.data.severity);
    }
    get onset() {
        return $definitions.selects.getValue(CONDITION_ONSET_SELECT_ID, this.data.onset);
    }
    get note() {
        return this.data.note;
    }
}
